import(/* webpackMode: "eager", webpackExports: ["HomeView"] */ "/Users/feker/Desktop/Feker-repo/ShahenWebsite/src/sections/_home/view/home-view.jsx");
